import type { Language } from '@client-info/i18n/locales';
import type { AppInfo } from '@client-info/routes/signup/-org/AppInfo';
import { queryOptions, useQuery } from '@tanstack/react-query';

export interface BrandConfig {
  appName?: string;
  cookiePolicy?: Partial<Record<Language, boolean>>;
  signup?: {
    org?: {
      appInfo?: Partial<AppInfo>;
    };
  };
}

export const brandConfigQueryOptions = queryOptions({
  queryKey: ['brandConfig'],
  queryFn: () =>
    fetch('/assets/config.json').then((res) => res.json() as BrandConfig),
});

export const useBrandingConfig = () => useQuery(brandConfigQueryOptions);

export default useBrandingConfig;
